import { render, staticRenderFns } from "./StaffPageControl.vue?vue&type=template&id=340ae538&scoped=true&"
import script from "./StaffPageControl.vue?vue&type=script&lang=js&"
export * from "./StaffPageControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340ae538",
  null
  
)

export default component.exports